import { graphql } from ':src/graphql';

export const entitiesByEmailsQuery = graphql(`
  query EntitiesByEmailsQuery($emails: [String!]!) {
    entitiesByEmails(emails: $emails) {
      ... on User {
        id
        email
        fullName
        isSupervisor
        isSupervisee
        hasOpenIncidents
        passwordSetAt
        supervisorApplication {
          id
        }
        supervisorIncidentStrikes {
          id
        }
      }
      ... on OrganizationAdmin {
        id
        email
        fullName
        organizationId
      }
    }
  }
`);

export const userDetailsByIdQuery = graphql(`
  query UserDetailsByIdQuery($id: Int!, $afterDate: Date) {
    userById(id: $id) {
      id
      fullName
      email
      phone
      passwordSetAt
      createdAt
      slug
      isSupervisor
      isSupervisee
      supervisorApplication {
        id
      }
      supervisorIncidents {
        id
        incidentDate
        incidentReportStatus {
          name
        }
        complianceIssues {
          id
        }
        conductIssues {
          id
        }
      }

      supervisorIncidentStrikes {
        id
        createdAt
        comments
        createdByAdmin {
          fullName
        }
      }

      usersLicenses {
        id
        usState {
          abbreviation
        }
        license {
          displayName
        }
      }

      superviseeProfile {
        id
        license {
          id
          displayName
        }
        licenseCategory {
          id
          abbreviation
        }
        licensureUsState {
          id
          abbreviation
        }
      }

      superviseeMatches {
        id
        supervisee {
          id
          fullName
          slug
          organization {
            id
            name
          }
          organizationUser {
            organizationProgram {
              name
            }
          }
        }
      }

      supervisorMatches(activeOnly: true) {
        id
        supervisor {
          id
          fullName
        }
      }

      organizationUser {
        id
        organization {
          id
          name
        }
        organizationProgram {
          id
          name
        }
      }
    }

    sessions(limit: 3, offset: 0, userId: $id, afterDate: $afterDate, sort: ASC) {
      result {
        id
        createdBy
        supervisor {
          id
          fullName
        }
        scheduledAt
        sessionTypeId
        sessionType {
          id
          displayName
        }
        sessionAttendees {
          id
          user {
            id
            fullName
          }
        }
      }
    }
  }
`);

export const organizationAdminDetailsByIdQuery = graphql(`
  query OrganizationAdminDetailsByIdQuery($id: Int!) {
    organizationAdminById(id: $id) {
      id
      fullName
      email
      phone

      organization {
        id
        name
        salesforceAccountUrl
        accountManagerAdmin {
          id
          fullName
        }
        currentOrganizationRate {
          individualRateTotalInCents
          dyadRateTotalInCents
          groupRateTotalInCents
          effectiveDate
        }
        nextOrganizationRate {
          effectiveDate
        }
        organizationUsers {
          user {
            superviseeProfile {
              licensureUsState {
                id
                abbreviation
                name
              }
            }
          }
        }
        organizationOnboardings(excludeCompleted: true) {
          id
          usState {
            id
            abbreviation
            name
          }
          onboardingStatus {
            id
            name
          }
          organizationOnboardingComments {
            id
            comment
            createdAt
            submittedByAdmin {
              id
              fullName
            }
          }
        }
      }

      organizationRole {
        name
      }

      organizationPrograms {
        id
        name
      }
    }
  }
`);
